/**
 * Types for the Critical House Information feature.
 * These types define the structure of the important information document
 * that will be saved as a JSON document with the CRITICAL_INFO_JSON_TAG.
 */

export interface SystemField {
	name: string;
	value: string;
}

export const CriticalSystemTypes = {
	Critical: 'critical',
	Suggested: 'suggested',
	Custom: 'custom',
} as const;

export type CriticalSystemType = (typeof CriticalSystemTypes)[keyof typeof CriticalSystemTypes];

export interface CriticalSystem {
	name: string;
	fields: SystemField[];
	type: CriticalSystemType;
}

export interface CriticalInfoDocument {
	systems: CriticalSystem[];
	version: string;
}
